module.exports = __webpack_public_path__ + "img/1.3525459b.png";